export default "__VITE_ASSET__DMoNdiS8__"